export interface ITenantData {
    rowid: string,
    tenant_name?: string
    logo_url?: string
    created_at?: Date
    updated_at?: Date
    last_updated_project?: Date

}

export interface SalesforceApp {
    id: string,
    name: string,
    label: string,
    version: string
    templateId: string
}

export interface SalesforceDashboard {
    id: string,
    name: string,
    label: string,
    url: string
}

export interface TriageProduct {
    customerid: string
    producttype_name: string
}

export interface TriageCustomer {
    id: string
    name: string
    organization_id?: string
    is_production?: boolean
}

export type ProcessingDetailLine = {
    icon: any;
    iconCls?: string
    lineType:string
    title: string
    progress: number
    total: number
    substeps: any
    error?: boolean
    status: string
    messages?: ValidationPushMessage    
    processorOutputUrl: string
    ignore_failed_validation?: boolean
    task_data?: any;
}

export interface ValidationMessage {
    message: string,
    state: 'info' | 'warning' | 'error',
    impact: 'low' | 'high'
}

export interface ValidationPushMessage{
    messages: ValidationMessage[],
}

export enum UserRole {
    ADMIN       = "admin",
    USER        = "user",
    GUEST       = "guest"
}